import {PUNCHLIST} from "../../../services";
import {FileController} from "../../Boilerplate/FileController";

const docKey = ['match', 'params', 'id'];
const subDocKey = ['match', 'params', 'punchListId'];
const indexType = 'punchlistitem';
const topLevelName = 'Punch Item';

export const PunchListFiles = FileController(PUNCHLIST, indexType, docKey, subDocKey, topLevelName);



// WEBPACK FOOTER //
// ./src/components/Projects/PunchList/PunchListFiles.js